import {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {getProductById} from '../../data/Products';
import ProductDetail from '../../components/ProductDetail';

function ProductDetailContainer(){
    const { id } = useParams();
    const [product, setProduct] = useState(null);

    useEffect(()=>{
        setProduct(getProductById(id));
        console.log(product);
    }, [id])
    return <main className="home-container">
        {product && <ProductDetail item={product}/>}
    </main>
}

export default ProductDetailContainer;